import { useHealth } from '../api/queries';
import { t } from '../i18n/pt-BR';

/** Estado do Datasul visto pelo BFF (`GET /api/health`). Em modo mock mostra `mock`. */
export function HealthBadge() {
  const { data, isError, isLoading } = useHealth();
  const datasul = isError ? 'down' : isLoading || !data ? 'unknown' : data.datasul;
  const tone = datasul === 'ok' ? 'ok' : datasul === 'mock' ? 'warn' : datasul === 'down' ? 'bad' : 'info';
  return (
    <span data-testid="health">
      {t.health.label}:{' '}
      <span className={`chip ${tone}`}>{datasul === 'mock' ? 'mock' : t.health[datasul]}</span>
      {datasul === 'mock' ? <span className="sr-only"> — {t.health.mock}</span> : null}
    </span>
  );
}
